import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';

function Navigation({ navigateToAnchor }) {
    const goAnchor = (e, anchor) => {
        e.preventDefault();
        if (navigateToAnchor) navigateToAnchor(anchor);
    };
    const goTop = (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    return (
        <Navbar expand="lg" className="bg-transparent site-nav">
            <Container>
                <Navbar.Brand href="#" onClick={goTop} className="d-flex align-items-center gap-2">
                    <img
                        src={`${process.env.PUBLIC_URL}/brand/referom-mark-192.png`}
                        srcSet={`${process.env.PUBLIC_URL}/brand/referom-mark-192.png 1x, ${process.env.PUBLIC_URL}/brand/referom-mark-512.png 2x`}
                        alt=""
                        aria-hidden="true"
                        className="brand-mark"
                    />
                    <span className="brand-name">Referom</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto align-items-lg-center">
                        <Nav.Link href="#why" onClick={(e) => goAnchor(e, 'why')}>Why Referom</Nav.Link>
                        <Nav.Link href="#audiences" onClick={(e) => goAnchor(e, 'audiences')}>For</Nav.Link>
                        <Nav.Link href="#integration" onClick={(e) => goAnchor(e, 'integration')}>Integration</Nav.Link>
                        <Nav.Link href="#how" onClick={(e) => goAnchor(e, 'how')}>How It Works</Nav.Link>
                        <Nav.Link href="#vision" onClick={(e) => goAnchor(e, 'vision')}>Vision</Nav.Link>
                        <Nav.Link href="#contact" onClick={(e) => goAnchor(e, 'contact')}>Contact</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Navigation;
